'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("coucheAdditionnelleService", function ($modal, $http, $dialogBox, $q, contextService) {
  var createPopinOptions = {
    controller: "CoucheAdditionnelleCreationPopinController",
    template: require("./coucheAdditionnelleCreationPopin.html")
  };
  var coucheAdditionnelles = null;
  var loadIfRequired = function loadIfRequired() {
    if (coucheAdditionnelles == null) {
      return doServerSync();
    } else {
      return coucheAdditionnelles;
    }
  };
  var doServerSync = function doServerSync() {
    var deferred = $q.defer();
    $http.get("/rest/saisie/couche-additionnelle/list").then(function (response) {
      coucheAdditionnelles = response.data;
      deferred.resolve(coucheAdditionnelles);
    });
    return deferred.promise;
  };
  return {
    $reload: function $reload() {
      return doServerSync();
    },
    findAll: function findAll() {
      return $q.when(loadIfRequired()).then(function () {
        return coucheAdditionnelles;
      });
    },
    openCreationPopin: function openCreationPopin() {
      return $modal.open(_.extend(createPopinOptions, {
        vars: {
          edit: false
        }
      }));
    },
    openEditionPopin: function openEditionPopin(coucheAdditionnelle) {
      return $modal.open(_.extend(createPopinOptions, {
        vars: {
          coucheAdditionnelle: coucheAdditionnelle,
          edit: true
        }
      }));
    },
    /**
     * Suppression de la classification. Si echec, affiche un message d'erreur
     * @param coucheAdditionnelleId
     * @returns {*}
     */
    delete: function _delete(coucheAdditionnelleId) {
      return $http.delete("/rest/saisie/couche-additionnelle/delete/" + coucheAdditionnelleId).then(function (response) {
        var result = response.data;
        if (!result.valid) {
          $dialogBox.alert({
            title: "Impossible de supprimer la couche additionnelle",
            text: result.message
          });
        } else {
          // invalidations si nécessaire
        }
        return result;
      });
    },
    /**
     *
     * @return normalement une valeur directement (et non une promesse)
     */
    findById: function findById(coucheAdditionnelleId) {
      return $q.when(loadIfRequired()).then(function () {
        for (var i = 0; i < coucheAdditionnelles.length; i++) {
          if (coucheAdditionnelles[i].id === coucheAdditionnelleId) {
            return coucheAdditionnelles[i];
          }
        }
        return null;
      });
    },
    /**
     *
     * @param appId optionnel, ne retourne que ceux associés à l'application
     * @return {*} retourne la promise
     */
    findAllByAppId: function findAllByAppId(appId) {
      return $http.get("/rest/saisie/couche-additionnelle/list", {
        params: {
          appId: appId
        }
      }).then(function (result) {
        return result.data;
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/coucheAdditionnelle/coucheAdditionnelleService.js
// module id = 2770
// module chunks = 13